// @flow
import React, { Suspense, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

// constants
import * as layoutConstants from "../../data/layout";

// utils
import { changeBodyAttribute } from "../../utils";

// components
import ThemeCustomizer from "../../components/ThemeCustomizer/";

// code splitting and lazy loading
// https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
const TopBar = React.lazy(() => import("../TopBar"));
const Navbar = React.lazy(() => import("./Navbar"));
const RightSidebar = React.lazy(() => import("../RightSidebar"));

const loading = () => <div className="text-center"></div>;

/**
 * Componente con el layout horizontal
 *
 * @param {object} children - Componentes hijos
 * @param {object} state - Estado del componente
 * @returns {JSX.Element} Componente de React
 */
const HorizontalLayout = ({ children }, state) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  const { layoutColor, showRightSidebar, layoutWidth } = useSelector(
    (state) => ({
      layoutColor: state.Layout.layoutColor,
      layoutWidth: state.Layout.layoutWidth,
      showRightSidebar: state.Layout.showRightSidebar,
    })
  );

  /**
   * Open the menu when having mobile screen
   */
  const openMenu = () => {
    setIsMenuOpened(!isMenuOpened);
    if (document.body) {
      if (isMenuOpened) {
        document.body.classList.remove("sidebar-enable");
      } else {
        document.body.classList.add("sidebar-enable");
      }
    }
  };

  // useEffect(() => {
  //   changeBodyAttribute("data-layout", layoutConstants.LAYOUT_HORIZONTAL);
  //   changeBodyAttribute(
  //     "data-leftbar-theme",
  //     layoutConstants.LEFT_SIDEBAR_THEME_DEFAULT
  //   );
  //   changeBodyAttribute(
  //     "data-leftbar-compact-mode",
  //     layoutConstants.LEFT_SIDEBAR_TYPE_FIXED
  //   );
  // }, []);

  useEffect(() => {
    changeBodyAttribute("data-layout-color", layoutColor);
  }, [layoutColor]);

  // useEffect(() => {
  //   changeBodyAttribute("data-layout-mode", layoutWidth);
  // }, [layoutWidth]);

  return (
    <>
      <div className="wrapper">
        <div className="content-page">
          <div className="content">
            <Suspense fallback={loading()}>
              <TopBar
                isMenuOpened={isMenuOpened}
                openLeftMenuCallBack={openMenu}
                navCssClasses="topnav-navbar topnav-navbar-dark"
                topbarDark={true}
              />
            </Suspense>

            <Suspense fallback={loading()}>
              <Navbar isMenuOpened={isMenuOpened} />
            </Suspense>

            <Container fluid>
              <Outlet />
            </Container>
          </div>

          {showRightSidebar && (
            <Suspense fallback={loading()}>
              <RightSidebar>
                <ThemeCustomizer />
              </RightSidebar>
            </Suspense>
          )}
        </div>
      </div>
    </>
  );
};

export default HorizontalLayout;
